import { css } from "@emotion/react";

export const footerWrapCss = css`
    width: 100%;
    background-color: #101010;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 380px;
    
    @media (max-width: 768px) {
        min-height: auto;
    }
    
    .footerLogo {
        margin-top: 81px;
    }
`;
export const footerCenterBoxCss = css`
    display: flex;
    flex-direction: column;
    margin-top : 35px;
    height: 100%;
    
    ul {
        padding-left: 0;
    }
    

    .list {
        list-style: none;
        margin: 0;
        padding: 0;
        align-items: center;
        display: flex;
        flex-direction: row;
        justify-content: center;

        li {
            color: #fff;
            font-size: 16px;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
        }



        a {
            color: #fff;
            font-size: 16px;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
        }
        
        
        .divide {
            width: 1px;
            height: 17.5px;
            background: #fff;
            margin: 3px 14px;
        }


        @media (max-width: 450px) {
            flex-direction: column;
            gap:10px;


            .divide {
                display: none;
            }
        }
        
        
    }

    .subList {
        display: flex;
        flex-direction: row;
        justify-content: center;
        color: #959AAB;
        margin-top: 16px;
        align-items: center;

        li {
            color: #959AAB;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
        }
        .divide {
            width: 1px;
            height: 14px;
            background: #959AAB;
            margin: 3px 11px;
        }
    }

    .lastList {
        display: flex;
        flex-direction: row;
        justify-content: center;
        color: #959AAB;
        align-items: center;

        @media (max-width: 380px) {
            flex-direction: column;
            gap:10px;
        }
        
        

        li {
            color: #959AAB;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
        }
        .divide {
            width: 1px;
            height: 14px;
            background: #959AAB;
            margin: 3px 11px;
        }


        @media (max-width: 380px) {
            .divide {
                display: none;
            }

        }
        
    }
    
    .copyrightList{
        display: flex;
        flex-direction: column;
        justify-content: center;


        @media (max-width: 1200px) and (min-width: 380px) {
            display: flex;
            padding: 20px 0px;
            flex-direction: column;
            align-items: center;
            gap: 12px;
            align-self: stretch;
        }

        @media (max-width: 380px) {
            display: flex;
            padding: 20px 0px;
            flex-direction: column;
            align-items: center;
            gap: 12px;
            align-self: stretch;
        }
        
        .line {
            width: 1200px;
            height: 0.5px;
            border: 1px solid #fff;
        }

        @media (max-width: 1200px) and (min-width: 380px) {
            .line {
                width: 500px;
            }
        }

        @media (max-width: 380px) {
            .line {
                width: 300px;
            }
        }
        
        
        .copyRight {
            color: #fff;
            font-size: 14px;
            margin-top: 20px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;

         
        }

     
        
    }
    
`;
